import { useEffect } from "react";

const BASE =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "https://ehs-remote.emergent.host");
const DEFAULT_TITLE = "Wasserlab — EHS Remote | U.S. Tier II & EPCRA Compliance Support";
const DEFAULT_DESC =
  "Remote Tier II, EPCRA, chemical inventory and environmental compliance support for U.S. industrial facilities, delivered by a specialized environmental engineering team.";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (data) {
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  } else if (el) {
    el.remove();
  }
}

export function useSEO({ title, description, path = "", jsonLd = null } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Wasserlab — EHS Remote` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = `${BASE}${path}`;
    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", "Wasserlab — EHS Remote");
    upsertMeta("property", "og:image", `${BASE}/og-image.png`);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", `${BASE}/og-image.png`);
    upsertCanonical(url);
    upsertJsonLd("page-jsonld", jsonLd);
    return () => upsertJsonLd("page-jsonld", null);
  }, [title, description, path, jsonLd]);
}

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Wasserlab",
  description: DEFAULT_DESC,
  areaServed: "US",
  serviceType: "Environmental Compliance Support",
  url: BASE,
};
